import { apiGet, apiPost } from '../config/api';

export const getApplicationForm = (user) =>
  apiGet('/student-portal/application', user);

export const saveApplicationForm = (user, data) =>
  apiPost('/student-portal/application', user, data);
